import React, { useState } from "react";
import { Field } from "formik";
import { ReactstrapInput } from "reactstrap-formik";
import * as Yup from "yup";
import { Row, Col } from "reactstrap";
import CrudEdit from "../Crud/Edit";
import PbxGroupService from "core/api/PbxGroupService";
import { paths } from "utils/PathService";
import { useParams} from "react-router-dom";
import { PasswordInputComponent } from "./PasswordInputComponent";


const PbxGroupSchema = Yup.object().shape({
  name: Yup.string().required("Required"),
  primaryUrl: Yup.string().required("Required"),
  primaryPort: Yup.mixed().required("Required").test("validate-number", "Must be a valid number", (value) => {
    if (value === null || value === undefined || value === "") return false;
    return /^\d+$/.test(String(value).trim());
  }),
  backupUrl: Yup.string().required("Required"),
  backupPort: Yup.mixed().required("Required").test("validate-number", "Must be a valid number", (value) => {
    if (value === null || value === undefined || value === "") return false;
    return /^\d+$/.test(String(value).trim());
  }),
});

const Edit = () => {
  let { id } = useParams();
  const initialData = {
    id: null,
    name: "",
    primaryUrl: "",
    primaryPort: "",
    primaryAmiUsername: "",
    primaryAmiSecret: "",
    backupUrl: "",
    backupPort: "",
    backupAmiUsername: "",
    backupAmiSecret: ""
  };


  return (
    <>
      <CrudEdit
        title="Pbx Group"
        initData={initialData}
        crudService={PbxGroupService}
        validationSchema={PbxGroupSchema}
        getRedirectPath={id ? null : (groupID) => paths.pbxGroup.view(groupID)}
        getData={(id) => PbxGroupService.getWithAmiInfo(id)}
        transformValues={(values) => ({
          ...values,
          primaryPort: Number(String(values.primaryPort).trim()),
          backupPort: Number(String(values.backupPort).trim()),
        })}

      >

        <Row>
          <Col>
            <Field
              type="text"
              name="name"
              label="Name"
              component={ReactstrapInput}
            />
          </Col>
        </Row>
        <Row>
          <Col md={4}>
            <Field
              type="text"
              name="primaryUrl"
              label="Primary Url"
              component={ReactstrapInput}
            />
          </Col>
          <Col md={2}>
            <Field
              type="text"
              name="primaryPort"
              label="Primary Port"
              component={ReactstrapInput}
            />
          </Col>
          <Col md={3}>
            <Field
              type="text"
              name="primaryAmiUsername"
              label="Primary AMI Username"
              component={ReactstrapInput}
            />
          </Col>
          <Col md={3}>
            <Field
              type="text"
              name="primaryAmiSecret"
              label="Primary AMI Secret"
              component={PasswordInputComponent}
            />
          </Col>
        </Row>
        <Row>
          <Col md={4}>
            <Field
              type="text"
              name="backupUrl"
              label="Backup Url"
              component={ReactstrapInput}
            />
          </Col>
          <Col md={2}>
            <Field
              type="text"
              name="backupPort"
              label="Backup Port"
              component={ReactstrapInput}
            />
          </Col>
          <Col md={3}>
            <Field
              type="text"
              name="backupAmiUsername"
              label="Backup AMI Username"
              component={ReactstrapInput}
            />
          </Col>
          <Col md={3}>
            <Field
              type="text"
              name="backupAmiSecret"
              label="Backup AMI Secret"
              component={PasswordInputComponent}
            />
          </Col>

        </Row>

      </CrudEdit>
    </>
  );
};

export default Edit;
